<template>
  <AgentChat />
</template>

<script>
import AgentChat from '@/components/AgentChat';

export default {
  name: 'PlatformChat',
  components: {
    AgentChat,
  },
};
</script>

<style lang="sass">
.CopyrightSection
  display: none
</style>
